import React, { useState } from "react";
import { CustomSecondaryInput } from "../../Core/Components/CustomInput";

const Screen6 = ({ setScreen, details, setDetails }) => {
  const [error, setError] = useState({
    lat: "",
    long: "",
  });

  const disabled =
    details?.baseLocation === "" || details?.lat === "" || details?.long === "";

  const handleContinue = () => {
    const lat = Number(details.lat);
    const long = Number(details.long);

    if (Number.isNaN(lat) || lat < -90 || lat > 90) {
      setError((prev) => ({
        ...prev,
        lat: "Please enter a valid number for latitude",
      }));

      return;
    }

    // Longitude validation
    if (Number.isNaN(long) || long < -180 || long > 180) {
      setError((prev) => ({
        ...prev,
        long: "Please enter a valid number for longitude",
      }));

      return;
    }

    setScreen(7);
  };

  return (
    <div className="flex flex-col">
      <h1 className="font-poppins text-2xl text-background-white font-semibold text-center">
        Location details
      </h1>

      <p className="my-4 font-poppins text-sm font-normal text-background-white-hover text-center">
        Where is your organization located?
      </p>

      <div className="flex flex-col gap-y-3">
        <CustomSecondaryInput
          value={details.baseLocation}
          placeholder="Enter base location"
          onChange={(e) =>
            setDetails({ ...details, baseLocation: e.target.value })
          }
        />

        <CustomSecondaryInput
          value={details.lat}
          autoFocus={false}
          placeholder="Enter latitude"
          onChange={(e) => {
            setDetails({ ...details, lat: e.target.value });
            setError((prev) => ({ ...prev, lat: "" }));
          }}
        />

        <CustomSecondaryInput
          value={details.long}
          autoFocus={false}
          placeholder="Enter longitude"
          onChange={(e) => {
            setDetails({ ...details, long: e.target.value });
            setError((prev) => ({ ...prev, long: "" }));
          }}
        />
      </div>

      {error?.lat || error?.long ? (
        <p className="mt-2 font-poppins text-xs font-normal text-background-white-hover">
          {error?.base || error?.lat || error?.long}
        </p>
      ) : null}

      <button
        type="button"
        className="mt-[50px] w-full h-[42px] py-3 rounded-md bg-yellow hover:bg-yellow-dark disabled:cursor-not-allowed"
        // onClick={() => setScreen(7)}
        onClick={handleContinue}
        disabled={disabled}
      >
        <p className="font-poppins text-xs font-medium">Continue</p>
      </button>
    </div>
  );
};

export default Screen6;
